import React, { useState, useEffect } from 'react';
import { Input } from 'components/Input';
import { InputV2 } from 'components/InputV2';

/**
 * @param {string} formattedNumber - The formatted US number to parse out,
 *     in the format +1 XXX-XXX-XXXX
 * @returns {string} Just the valid numeric string for a US phone number,
 *     stripping out the initial +1, the dashes and any initial 1
 */
function parseNumber(formattedNumber) {
  return formattedNumber.replace(/\D/g, '').replace(/^1+/, '');
}

function formatPhoneNumber(phone) {
  const input = parseNumber(phone);
  const areaCode = input.substring(0, 3);
  const middle = input.substring(3, 6);
  const last = input.substring(6, 10);

  if (input.length > 6) {
    return `+1 ${areaCode}-${middle}-${last}`;
  }

  if (input.length > 3) {
    return `+1 ${areaCode}-${middle}`;
  }

  if (input.length > 0) {
    return `+1 ${areaCode}`;
  }

  return '+1 ';
}

export function PhoneNumberInput({
  style,
  name,
  label,
  type = 'text',
  error,
  icon,
  onChange = () => { },
  onBlur = () => { },
  placeholder,
  value,
  ...props
}) {
  const [displayNumber, setDisplayNumber] = useState(formatPhoneNumber(value));

  useEffect(() => {
    onChange({ name, value: parseNumber(displayNumber) });
  }, [displayNumber]);

  return (
    <Input
      style={style}
      name={name}
      label={label}
      type={type}
      error={error}
      icon={icon}
      onInput={(e) => setDisplayNumber(formatPhoneNumber(e.target.value))}
      onBlur={onBlur}
      placeholder={placeholder}
      value={displayNumber}
      {...props}
    />
  );
}

export function PhoneNumberInputV2({
  style,
  name,
  label,
  type = 'text',
  error,
  icon,
  onChange = () => { },
  onBlur = () => { },
  placeholder,
  value,
  ...props
}) {
  const [displayNumber, setDisplayNumber] = useState(formatPhoneNumber(value));

  useEffect(() => {
    onChange({ name, value: parseNumber(displayNumber) });
  }, [displayNumber]);

  return (
    <InputV2
      style={style}
      name={name}
      label={label}
      type={type}
      error={error}
      icon={icon}
      onInput={(e) => setDisplayNumber(formatPhoneNumber(e.target.value))}
      onBlur={onBlur}
      placeholder={placeholder}
      value={displayNumber}
      {...props}
    />
  );
}